import { render, staticRenderFns } from "./ProductFabricPalletImages.vue?vue&type=template&id=5abd29f0&scoped=true&"
import script from "./ProductFabricPalletImages.vue?vue&type=script&lang=js&"
export * from "./ProductFabricPalletImages.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/fabricPalletImages/ProductFabricPalletImagesStyle.css?vue&type=style&index=0&id=5abd29f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd29f0",
  null
  
)

export default component.exports